var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBook5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6276 18.0573C2.0026 18.0573 1.46441 17.8455 1.01302 17.4219C0.561632 16.9983 0.335938 16.474 0.335938 15.849V4.22396C0.335938 3.69618 0.499132 3.22396 0.825521 2.80729C1.15191 2.39062 1.57899 2.12674 2.10677 2.01563L10.3359 0.390625V13.724L2.4401 15.3073C2.3151 15.3351 2.21094 15.401 2.1276 15.5052C2.04427 15.6094 2.0026 15.724 2.0026 15.849C2.0026 16.0017 2.0651 16.1302 2.1901 16.2344C2.3151 16.3385 2.46094 16.3906 2.6276 16.3906H12.0026V3.05729H13.6693V18.0573H2.6276ZM4.5026 13.2031L8.66927 12.3906V2.43229L4.5026 3.24479V13.2031ZM2.83594 13.5365V3.57813L2.52344 3.64063C2.37066 3.6684 2.24566 3.73438 2.14844 3.83854C2.05122 3.94271 2.0026 4.07118 2.0026 4.22396V13.7448C2.07205 13.717 2.14497 13.6927 2.22135 13.6719C2.29774 13.651 2.37066 13.6337 2.4401 13.6198L2.83594 13.5365Z",
    fill: "url(#paint0_linear_2057_9168)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2057_9168",
    x1: 7.0026,
    y1: 0.390625,
    x2: 7.0026,
    y2: 18.0573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook5);
export default __webpack_public_path__ + "static/media/book_5.269f34533d9a15313b6d6fa2abc22bf0.svg";
export { ForwardRef as ReactComponent };